import actions from './action';
import charts from './chart';
import clients from './client';
import commcaches from './commCache';
import dashboards from './dashboard';
import events from './event';
import sensortypes from './sensortype';
import threads from './threads';
import triggerableStats from './triggerablestat';
import units from './unit';
import unitgroups from './unitgroups';
import unitsensors from './unitsensor';
import userComments from './userComment';

export default {
    actions,
    charts,
    clients,
    commcaches,
    dashboards,
    events,
    sensortypes,
    threads,
    triggerableStats,
    units,
    unitgroups,
    unitsensors,
    userComments
};


// WEBPACK FOOTER //
// ./src/stores/application/index.ts